// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BJ0r","clinicsSelect":"styles_clinicsSelect__2IN6t"};